import React from "react"
import { Box, Grid, Text, Container } from "@jjordy/layout"
import { Link } from "@reach/router"
import styled from "styled-components"
import List, { ListItem } from "./List"
import useWindowSize from "./useWindowSize"

const StyledFooter = styled(Box)`
  position: relative;
  width: 100%;
  bottom: 0;
  left: 0;
  & a {
    color: #fff;
    text-decoration: none;
    font-weight: normal;
  }
`

export interface FooterProps {
  children?: React.ReactNode
  [rest: string]: any
}

export default function Footer({ children, ...rest }: FooterProps) {
  const { width } = useWindowSize()
  return (
    <StyledFooter bg="primary" rounded={false} p={width > 768 ? 4 : 0} {...rest}>
      <Container text>
        <Grid width="25%" gap={16}>
          <List>
            <ListItem>
              <Text fg="white">FEATURE FLAGGED</Text>
            </ListItem>
            <ListItem />
            <ListItem />
            <ListItem />
            <ListItem>@ 2019 Feature Flagged</ListItem>
          </List>
          <List>
            <ListItem>
              <Text fg="white">PRODUCTS</Text>
            </ListItem>
            <ListItem>
              <Link to="/">Feature Flagged</Link>
            </ListItem>
          </List>
          <List>
            <ListItem>
              <Text fg="white">DEVELOPERS</Text>
            </ListItem>
            <ListItem>
              <Link to="/">Documentation</Link>
            </ListItem>
            <ListItem>
              <Link to="/">API Reference</Link>
            </ListItem>
            <ListItem>
              <Link to="/">Libraries</Link>
            </ListItem>
          </List>
          <List>
            <ListItem>
              <Text fg="white">COMPANY</Text>
            </ListItem>
            <ListItem>
              <Link to="/">About</Link>
            </ListItem>
            <ListItem>
              <Link to="/">Customers</Link>
            </ListItem>
            <ListItem>
              <Link to="/">Contact Us</Link>
            </ListItem>
            <ListItem>
              <Link to="/">Legal</Link>
            </ListItem>
          </List>
        </Grid>
        {children}
      </Container>
    </StyledFooter>
  )
}
